module.exports = __webpack_public_path__ + "img/332x454px.8d8a2757.jpg";